<select [ngModel]="value" (ngModelChange)="changeValue($event)">
    <option value="P">Paragraph</option>
    <option value="H1">Heading 1</option>
    <option value="H2">Heading 2</option>
    <option value="H3">Heading 3</option>
    <option value="H4">Heading 4</option>
    <option value="H5">Heading 5</option>
    <option value="H6">Heading 6</option>
</select>